module.exports = __webpack_public_path__ + "img/1_1-orto-2.a189b445.png";